import clsx from "clsx";
import React, { useState } from "react";
import { Control, FieldErrors } from "react-hook-form";
import { SetFieldValue, SetValueConfig } from "react-hook-form/dist/index.ie11";
import { ErrorOption } from "react-hook-form/dist/types/errors";
import { FieldName } from "react-hook-form/dist/types/fields";
import { useTranslation } from "react-i18next";

import FileLoader from "~/components/FileLoader";
import {
  FilePositionsForm,
  IPositionsForm,
} from "~/entity/Employee/model/positionsForm";
import { useGetLocationData } from "~/hooks/locationData";
import { toggleFileSizeError } from "~/shared/lib/toggleFileSizeError";

import s from "./FilePickerField.less";

interface IFilePickerField {
  control: Control;
  name: string;
  error: string;
  errors: FieldErrors<IPositionsForm>;
  DataConsent: FilePositionsForm;
  setValue: (
    name: FieldName<IPositionsForm>,
    value: SetFieldValue<IPositionsForm>,
    config?: SetValueConfig,
  ) => void;
  setError: (name: FieldName<IPositionsForm>, error: ErrorOption) => void;
  id: string;
  label: string;
}
const FilePickerField = ({
  errors,
  error,
  control,
  name,
  setError,
  DataConsent,
  setValue,
  id,
  label,
}: IFilePickerField) => {
  const { t } = useTranslation();
  const [isFull, setIsFull] = useState<boolean>(false);
  const { openModal } = useGetLocationData();
  const handleIsFullState = (isFile: boolean) => {
    setIsFull(isFile);
  };

  return (
    <div className={s.wrapper}>
      <div className={s.wrapper_radio}>
        <div className={s.name_radio}>{label}</div>
        <div className={s.drop_zone}>
          <div
            className={clsx(s.photos, {
              [s.photos_doc]: isFull,
              [s.photos_error]: error,
            })}
          >
            <div className={s.photos_text}>{t("employee.downloadDiv")}</div>

            <FileLoader
              name={name}
              control={control}
              withText
              sizeRestrictions={5}
              accept={".png, .jpg, .jpeg, .doc, .pdf, .docx"}
              id={id}
              showErrorHandler={(hide) =>
                toggleFileSizeError({ t, errors, setError })(hide, name)
              }
              error={error}
              customErrorStyle={s.correctErrorPos}
              download={openModal === "Add" ? DataConsent.id : DataConsent}
              setValue={setValue}
              handleIsFullToState={handleIsFullState}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default FilePickerField;
